import { render, staticRenderFns } from "./CustomizedAddThemeTemplate.vue?vue&type=template&id=48eda5e2&scoped=true"
import script from "./CustomizedAddThemeTemplate.vue?vue&type=script&lang=js"
export * from "./CustomizedAddThemeTemplate.vue?vue&type=script&lang=js"
import style0 from "./CustomizedAddThemeTemplate.vue?vue&type=style&index=0&id=48eda5e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eda5e2",
  null
  
)

export default component.exports